import React, { Component } from 'react';
import { Divider, Form, Popover, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import '../../expenses.less';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    const {
      dataSource: { pagination },
    } = this.state;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    let config = [
      {
        title: '编号',
        dataIndex: 'num',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '资料文件名称',
        dataIndex: 'no',
        render: (text, record) => {
          return <span>{record.document.name}</span>;
        },
      },
      {
        title: '资料归属公司',
        dataIndex: 'company',
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },

      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '约定归还时间',
        dataIndex: 'expectReturnDate',
        key: 'expectReturnDate',
        render: text => {
          let day = 0;
          if (this.props.type === 'todo') {
            day = Math.floor((Date.now() - text) / 86400000);
          }
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day > 0 ? <span style={{ color: 'red' }}>(逾期{day}天)</span> : ''}
              {day < 0 ? <span>(剩余{day}天)</span> : ''}
            </span>
          );
        },
      },
      {
        title: '实际归还时间',
        dataIndex: 'returnDate',
        key: 'returnDate',
        render: (text, record) => {
          let day = 0;
          if (record.expectReturnDate && text) {
            day = Math.floor((text - record.expectReturnDate) / 86400000);
          }
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}
              {day > 0 ? <span style={{ color: 'red' }}>(逾期{day}天)</span> : ''}
              {day < 0 ? <span>(提前{day}天)</span> : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              {record.borrowUuid ? (
                <Link to={`/administrative/material/borrow_manage/open/${record.borrowUuid}`}>
                  查看流程
                </Link>
              ) : null}
              {record.borrowUuid && this.props.type === 'todo' && this.props.type2 !== 'mine' ? (
                <Divider type="vertical" />
              ) : null}
              {this.props.type === 'todo' && this.props.type2 !== 'mine' ? (
                <a onClick={() => this.props.showModalReturn(record)}>资料借还</a>
              ) : null}
            </div>
          );
        },
      },
    ];

    if (this.props.type === 'todo') {
      config = config.filter(item => item.dataIndex !== 'returnDate');
    }
    return config;
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <div>
        <Table
          onChange={this.handleChange}
          columns={this.columns()}
          pagination={pagination}
          dataSource={list}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/material/return/TableExpenses.js